export default __webpack_public_path__ + "static/media/productValues1.3b851999.svg";